/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

module.exports = class HeaderSection {
	constructor() {
		this._size = 0;
		this._level = 0;
		this._visible = true;
		this._closed = false;
	}

	get properties() {
		return this._properties;
	}

	set properties(properties) {
		this._properties = properties
	}

	get format() {
		return this._properties ? this._properties.formats : undefined;
	}

	set format(format) {
		if (!this._properties) {
			this._properties = {};
		}
		this._properties.formats = format;
	}

	get textFormat() {
		return this._properties ? this._properties.textFormats : undefined;
	}

	set textFormat(format) {
		if (!this._properties) {
			this._properties = {};
		}
		this._properties.textFormats = format;
	}

	get attributes() {
		return this._properties ? this._properties.attributes : undefined;
	}

	set attributes(attributes) {
		if (!this._properties) {
			this._properties = {};
		}
		this._properties.attributes = attributes;
	}

	isDefault(defaultSize) {
		return (
			this._size === defaultSize &&
			this._level === 0 &&
			this._visible === true &&
			(this._closed === undefined || this._closed === false) &&
			this._properties === undefined
		);
	}

	copy() {
		const copy = new HeaderSection();

		return copy;
	}

	get level() {
		return this._level;
	}

	set level(value) {
		this._level = value;
	}

	get parent() {
		return this._parent;
	}

	set parent(value) {
		this._parent = value;
	}

	get closed() {
		return this._closed;
	}

	set closed(value) {
		this._closed = value;
	}

	reset({ size = 0, level = 0, visible = true} = {}) {
		this._size = size;
		this._level = level;
		this._visible = visible;
		this._closed = false;
		this.clearFormat();
	}

	getSize() {
		return this._size;
	}

	setSize(size) {
		this._size = size;
	}

	getVisible() {
		return this._visible;
	}

	setVisible(visible) {
		this._visible = visible;
	}

	clearFormat() {
		this._properties = undefined;
	}

	save(writer, index) {
		writer.writeStartElement('section');
		writer.writeAttributeNumber('index', index, 0);
		if (this._level) {
			writer.writeAttributeNumber('level', this._level, 0);
		}
		writer.writeAttributeNumber('size', this._size, 0);
		writer.writeAttributeNumber('visible', this._visible ? 1 : 0);
		if (this._closed) {
			writer.writeAttributeNumber('closed', 1);
		}

		if (this.format) {
			writer.writeStartElement('format');
			writer.writeObject(this.format);
			writer.writeEndElement();
		}
		if (this.textFormat) {
			writer.writeStartElement('textformat');
			writer.writeObject(this.textFormat);
			writer.writeEndElement();
		}
		if (this.attributes) {
			writer.writeStartElement('attributes');
			writer.writeObject(this.attributes);
			writer.writeEndElement();
		}

		writer.writeEndElement();
	}

	read(reader, object) {
		const ssize = reader.getAttribute(object, 'size');
		if (ssize !== undefined) {
			this._size = Number(ssize);
		}
		const level = reader.getAttributeNumber(object, 'level', 0);
		if (level !== undefined) {
			this._level = level;
		}
		const closed = reader.getAttribute(object, 'closed');
		if (closed !== undefined) {
			this._closed = true;
		}

		const visible = reader.getAttribute(object, 'visible');
		if (visible !== undefined) {
			this._visible = Number(visible) === 1;
		}

		reader.iterateObjects(object, (name, child) => {
			switch (name) {
			case 'format':
				this.format = child;
				break;
			case 'textformat':
				this.textFormat = child;
				break;
			case 'attributes':
				this.attributes = child;
				break;
			}
		});
	}
};
